module.exports = __webpack_public_path__ + "static/hero-6315b7824935f433a873261a450726a4.jpg";